import "../sass/Lightbox.scss";
import { useEffect } from "react";
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import Button from "@material-ui/core/Button";
import {IconButton} from "@material-ui/core";
 import CloseIcon from '@mui/icons-material/Close';

let projets = [];
let projet;


//On doit passer l'id du projet ici
export default function Lightbox({ etatLightbox, etatGalerie ,toggleLightbox, etatProjetChoisi }) {

    //Runs after render ! (useEffect runs asynchronously and after a render is painted to the screen.)
    //Rajouter des deps vides (,[]) pour que l'effet run uniquement après le 1er render
    useEffect(() => {
       
        //description = ;
        document.querySelector(".projectDesc").innerHTML = documentToHtmlString(projet.fields.description);

    });

    const [indexProjetChoisi, setIndex] = etatProjetChoisi;
    console.log(setIndex);
    
    projets = etatGalerie.fields.projets;

    const [eLightbox, setEtatLightbox] = etatLightbox;
    console.log(setEtatLightbox);

    let lightboxVideo;
    
    if (projets.length !== 0) {
       projet = projets[indexProjetChoisi];


        if (eLightbox === false) {
            lightboxVideo = <video src={(projets.length !== 0) ? projet.fields.videoGameplay.fields.file.url : ""} width="900" autoPlay loop muted controls title="Cliquez pour en savoir plus !"></video>;
        }
        else {
            lightboxVideo = <video src={(projets.length !== 0) ? projet.fields.videoGameplay.fields.file.url : ""} width="900" autoPlay loop controls title="Cliquez pour en savoir plus !"></video>;
        }

        //const mois = ["Janvier","Février", "Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"];

        let datePrefixe = etatGalerie.fields.dateDeRealisation;
        let jouer = etatGalerie.fields.jouer;

        return (
            <div className="Lightbox">
                
                <div className="leftSection">
                    {lightboxVideo}
                    <p>
                        <div className="projectDesc">
                            
                        </div>
                        <Button variant='contained' color='primary' href={projet.fields.lienDuJeu} target='blank'>{jouer}</Button>
                        <br/>
                        <span className="devNames">
                            {
                                projet.fields.developpeurs.map(dev => <a href={dev.fields.siteWeb} target="blank" key={dev.fields.nomComplet}>{dev.fields.nomComplet},</a>)
                            }
                        </span>
                        <span>{datePrefixe+' '+projet.fields.anneeDeRealisation}</span>
                    </p>

                </div>
                <div className="rightSection" >
                    
                
                    {
                        projet.fields.capturesEcran.map(image => <img key={image.fields.title} src={image.fields.file.url} title={image.fields.title} alt={image.fields.description} />)  
                    }

                </div>
                <IconButton size="large" color="primary" onClick={toggleLightbox}><CloseIcon fontSize="inherit"/></IconButton>
                {/* <Button className="closeButton" variant='contained' color='primary' onClick={toggleLightbox} target='blank'></Button> */}
            </div>

        )

    } 
    else 
    {
        return null;
    }
}

